import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import {VueAxios} from './axios'
import {ACCESS_TOKEN} from '@/store/mutation-types'
// import { outLoginPage } from '@/utils/uumsUtil'

/**
 * axios 参数配置
 * url: string 接口地址
 * baseURL: string 基路径，自动添加到url
 * method: string 请求方法
 * headers: object 自定义请求头
 * data: object |string 请求报文主体,
 * params: object | string 放url地址后，作为queryParams
 * timeout: number 请求超时
 * auth: object HTTP基础验证
 * responseType: string('json') 响应报文数据类型
 * proxy: object 基础代理
 * withCredentials: boolean 跨域请求时是否需要使用凭证
 */
// 创建 axios 实例

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api base_url
  timeout: 30000 // 请求超时时间
})

const err = (error) => {
  console.log(error)
  if (error.response) {
    const data = error.response.data
    // alert(data)
    // if (error.response.status === 403) {
    //   notification.error({
    //     message: data.message
    //   })
    // }
    // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
    //   notification.error({
    //     message: data.message
    //   })
    // }
  }
  return Promise.reject(error)
}

// request interceptor 请求前
service.interceptors.request.use(config => {
  // const token = Vue.ls.get(ACCESS_TOKEN)
  // if (token) {
  config.url = config.url
  //   config.url = config.url + '?token=' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  //  }
  return config
}, err)

// response interceptor请求返回
service.interceptors.response.use((response) => {
  const res = response.data
  const code = res.code
  // 200成功
  if (code === 200) {
    return res
  }
  // 认证返回错误 退出登录
  if (code === 400003) {
    notification.error({
      message: res.message
    })
    // outLoginPage()
    return Promise.reject(res)
  }
  return res
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js